import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isShow: false,
    loading: true,
    componentName: '',
    user: {
      account: '',
      // 实名登录显示类型： 0，不显示 1，登录后 2，充值前
      cert_type: 0,
      cert_url: '',
      force_cert_status: 0, // 0 未认证 1已认证未成年 2已认证且已成年
      is_bind: 0,
      // 是否强制实名，1，是 0，否
      is_force_cert: 0,
      // 是否是游客登录
      is_guest: 0,
      passwd: '',
      token: '',
      uid: ''
    },
    protocal_url: '', // 用户隐私协议
    is_agree: false, // 是否同意隐私协议
    guestInfo: {
      // 游客登录帐密
      guestAccount: '',
      guestPass: ''
    },
    // 需要传递的componentParams
    componentParams: undefined,
    // 打开新页面确认框
    openConfirmShow: false,
    // 需要跳转到的新页面
    openUrl: '',
    changeCompName: '',
    // 显示sdk红包开关
    rebateOpen: false,
    // 红包url
    rebateUrl: '',
    // 客服窗口
    kefu: {
      url: '',
      show: false
    },
    // 控制红包弹窗
    rebatePop: false,
    // 游戏声明
    gameState: false,
    // 游戏声明更新版本
    gameStateVer: '',
    // 切换账号按钮显示
    isHover: false,
    // 保存用户是否实名状态
    isCertName: true,
    // 登录唯一id,用于在线时长上报
    login_id: '',
    // 是否是国外ip
    abroadIp: false,
    series_id: String(new Date().valueOf()) + 'SI' + Math.floor(Math.random() * 100000 + 1),
    zoneId: '',
    // 绑定手机保存未实名数据
    bindPhoneCertData: {},
    // 快速注册2、账号登录1
    loginType: 1,
    // 是否点击切换账号
    isClickChangeAcc: false,
    show_bind: '', // 是否显示手机号绑定界面
    curr_user_info: { name: '', pwd: '' },
    changeAccClick: false, // 九梦切换账号是否点击
    forgetPwd: false,
    verticalRb: '', // 竖版红包
    healthBool: false, // 是否开启健康公告
    gameDist: '', // 游戏横竖屏
    isCloseSvPwd: false, // 游客首次注册是否有关闭手保存密码弹窗
    autoOpenReb: false, // 自动打开红包页面弹窗
    preRb: false, // 红包前置展示
    is_open_health: '', // 保存是否展示健康公告页
    preRbUrl: '', // 预展示红包链接
    initBind: '',
    changeBind: false,
    pushImgConfig: {}, // sdk推送图片配置
    pushImgShow: false, // 是否展示推送图片配置
    saveCurrComp: '', // 保存当前组件名
    userPhone: '',
    isOpenRebate: false, // 是否打开红包悬浮窗
    role_level_interval: 1000, // 角色等级延迟上报时间
    button_interval: 500, // 按钮点击防抖时间
    rebateIcon: {}, // 红包图标
    guestLoginData: {}, // 保存游客登录返回数据
  },
  getters: {
    isForceCert: state => state.user.is_force_cert == 1 || (state.componentParams && state.componentParams.isForceCert)
  },
  mutations: {
    SHOW(state, payload = 'PhoneLogin') {
      const isStringPayload = typeof payload === 'string';
      const componentName = isStringPayload ? payload : payload.name;
      const componentParams = isStringPayload ? undefined : payload.params || {};
      state.isShow = true;
      state.componentName = componentName;
      state.componentParams = componentParams;
    },
    CLOSE(state) {
      state.isShow = false;
    },
    TOGGLE(state, payload = 'PhoneLogin') {
      const isStringPayload = typeof payload === 'string';
      const componentName = isStringPayload ? payload : payload.name;
      const componentParams = isStringPayload ? undefined : payload.params || {};
      state.isShow = !state.isShow;
      state.componentName = state.isShow ? componentName : '';
      state.componentParams = componentParams;
    },
    SET_USER(state, user = {}) {
      state.user = user;
    },
    SET_PROURL(state, url) {
      state.protocal_url = url;
    },
    SET_COMPNAME(state, name) {
      state.changeCompName = name;
    },
    SET_ISAGREE(state, bool) {
      state.is_agree = bool;
    },
    SET_GUESTINFO(state, info = {}) {
      state.guestInfo = info;
    },
    SHOW_OPENCONFIRM(state, url = '') {
      state.openConfirmShow = true;
      state.openUrl = url;
    },
    CLOSE_OPENCONFIRM(state) {
      state.openConfirmShow = false;
      state.openUrl = '';
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_OPEN(state, openval) {
      state.rebateOpen = openval;
    },
    SET_RABTOPEN(state, openval) {
      state.rebatePop = openval;
    },
    SET_OPENKEFU(state, val = {}) {
      state.kefu = val;
    },
    SET_REBATEURL(state, url) {
      state.rebateUrl = url;
    },
    SET_GAMESTATE(state, bool) {
      state.gameState = bool;
    },
    SET_GAMESTATEVER(state, url) {
      state.gameStateVer = url;
    },
    SET_ISHOVER(state, bool) {
      state.isHover = bool;
    },
    SET_ISCERTNAME(state, bool) {
      state.isCertName = bool;
    },
    SET_LOGINID(state, val = '') {
      state.login_id = val;
    },
    SET_IP(state, val = false) {
      state.abroadIp = val;
    },
    SET_ZONEID(state, val = '') {
      state.zoneId = val;
    },
    SET_BINDCERT(state, val = {}) {
      state.bindPhoneCertData = val;
    },
    SET_LOGINTYPE(state, val = '') {
      state.loginType = val;
    },
    SET_CLICKACC(state, bool) {
      state.isClickChangeAcc = bool;
    },
    SET_SHOWBIND(state, bool) {
      state.show_bind = bool;
    },
    SET_INITBIND(state, val) {
      state.initBind = val;
    },
    SET_USER_INFO(state, data) {
      state.curr_user_info = {
        name: data.name,
        pwd: data.pwd
      };
    },
    SET_CHANGECLICK(state, bool) {
      state.changeAccClick = bool;
    },
    SET_FORGETPWD(state, bool) {
      state.forgetPwd = bool;
    },
    SET_VERTICALRB(state, val) {
      state.verticalRb = val;
    },
    SET_HEALTH(state, val) {
      state.healthBool = val;
    },
    SET_GAMEDIST(state, val) {
      state.gameDist = val;
    },
    SET_ISCLOSEPWD(state, val) {
      state.isCloseSvPwd = val;
    },
    SET_AUTOOPENREB(state, val) {
      state.autoOpenReb = val;
    },
    SET_PRERB(state, val) {
      state.preRb = val;
    },
    SET_OPEN_HEALTH(state, val) {
      state.is_open_health = val;
    },
    SET_PRERBURL(state, val) {
      state.preRbUrl = val;
    },
    SET_CHANGEBIND(state, val) {
      state.changeBind = val;
    },
    SET_PUSHCONFIG(state, val) {
      state.pushImgConfig = val;
    },
    SET_PUSHSHOW(state, val) {
      state.pushImgShow = val;
    },
    SAVECURRCOMP(state, val) {
      state.saveCurrComp = val;
    },
    SET_USERPHONE(state, val) {
      state.userPhone = val;
    },
    SET_IS_OPEN_REBATE(state, val) {
      state.isOpenRebate = val;
    },
    SET_ROLE_INTERVAL(state, val) {
      state.role_level_interval = val;
    },
    SET_BUTTON_INTERVAL(state, val) {
      state.button_interval = val;
    },
    SET_REBATE_ICON(state, val) {
      state.rebateIcon = val;
    },
    SET_GUEST_DATA(state, val) {
      state.guestLoginData = val;
    }
  },
  actions: {},
  modules: {}
});
